import React, { Component } from 'react';
import Navbar from 'react-bootstrap/lib/Navbar';
import PropTypes from 'prop-types';
import NavHeader from './NavbarHeader';
import NavLogout from './NavLogout';
import NavMenu from './NavMenu';
import { connect } from 'react-redux';

class NavbarComponent extends Component {
    navigation() {
        let isAuthenticated = this.props.childProps.isAuthenticated;

        if (isAuthenticated && this.props.childProps.employeeData !== undefined) {
            return (
                <NavMenu
                    isAdmin={this.props.childProps.isAdmin}
                    isManager={this.props.childProps.isManager}
                    isUser={this.props.childProps.isUser}
                    isSuperAdmin={this.props.childProps.isSuperAdmin}
                    avatar={this.props.userAvatar}
                />
            );
        } else if (!isAuthenticated) {
            return <NavLogout />;
        }
    }

    render() {
        return (
            <Navbar collapseOnSelect>
                <NavHeader isAuth={this.props.childProps.isAuthenticated} />
                {this.navigation()}
            </Navbar>
        );
    }
}

NavbarComponent.propTypes = {
    childProps: PropTypes.object,
    userAvatar: PropTypes.string
};

const mapStateToProps = state => ({
    userAvatar: state.userProfileData.userAvatar
});

export default connect(mapStateToProps)(NavbarComponent);



// WEBPACK FOOTER //
// ./src/components/Navbar/Navbar.js